import styles from "@/styles/article/faq.module.scss"
import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import Wholesale from "@/components/productDetail/Wholesale"
import TabBar from "@/components/TabBar"
import { UpOutlined } from '@ant-design/icons';

import { Button, message, Skeleton } from 'antd'

import { useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'

import getConfig from 'next/config'
import systemApi from "@/service/modules/systemApi"
import { useEffect } from "react"
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

interface FAQCategory {
  name: string;
  title: string;
  picture: string;
  sortorder: number;
  qaCategoryID: number;
  qa: {
    title: string;
    content: string;
    qaID: number;
  }[];
}

interface FAQApiResponse {
  status: number;
  code: number;
  message: string;
  data: {
    qaList: FAQCategory[];
  };
}
export default function Faq() {
  const [faqData, setFaqData] = useState<FAQCategory[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0)
  const [tabList, setTabList] = useState<any[]>([])


  useEffect(() => {
    getList()
  }, [])

  const getList = async () => {
    try {
      setIsLoading(true);
      const res = await systemApi.getFaqList();
      const apiData = res as unknown as FAQApiResponse;

      if (apiData.status === 200 && apiData.data?.qaList) {
        setFaqData(apiData.data.qaList);

        if (apiData.status === 200 && apiData.data?.qaList) {
          setFaqData(apiData.data.qaList);
          // 初始化tabList但不需要在这里处理active状态
          const initialTabList = apiData.data.qaList.map((category: any, index: number) => ({
            id: category.qaCategoryID,
            name: category.title,
            picture: category.picture,
            pictureActive: category.pictureActive,
            itemWidth: 'calc(100% / 7)',
            iconName: category.name.toLowerCase().replace(/[^a-z]/g, '')
          }));
          setTabList(initialTabList);
        }
      }
    } catch (error: any) {
      message.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };



  // 将API数据转换为页面需要的格式
  const transformFaqData = () => {
    if (!faqData.length) return [];

    return faqData.map(category => {
      return category.qa.map(item => ({
        question: item.title,
        answer: (
          <div className={styles['answer-desc']}
            dangerouslySetInnerHTML={{ __html: item.content }} />
        )
      }));
    });
  };

  const pageData: any = transformFaqData();
  // 切换tab，展示不同的内容
  const handleTabChange = (index: number) => {
    setActiveTab(index)
  }

  // 点击目录item，跳转到指定Faq的定位
  const scrollToTarget = (index: number) => {
    // 获取Faq目标div
    const targetDiv = document.getElementById(`${activeTab}${index}`);

    if (targetDiv) {
      // 计算目标div的位置
      const targetDivRect = targetDiv.getBoundingClientRect()

      // 滚动到目标div的位置
      window.scrollTo({
        top: targetDivRect.top - 90,
        behavior: 'smooth', // 添加平滑滚动效果
      })
    }
  }

  // 回到顶部
  const backToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // 添加平滑滚动效果
    })
  }

  // 批发佬弹窗控制
  const [isWholesaleOpen, setIsWholesaleOpen] = useState(false);
  const openWholesale = () => {
    setIsWholesaleOpen(true);
  };

  const closeWholesale = () => {
    setIsWholesaleOpen(false);
  };

  interface QuestionItem {
    question: string;
    answer: React.ReactNode;
  }
    useEffect(() => {
    const target = document.body; // 监听整个 body
    const observer = new MutationObserver(() => {
      const btn = document.getElementById("contactUs");
      if (btn) {
        btn.addEventListener("click", handleClick);
        observer.disconnect(); // 只执行一次
      }
    });

    observer.observe(target, { childList: true, subtree: true });

    const handleClick = () => {
      openWholesale()
    };

    return () => {
      const btn = document.getElementById("contactUs");
      if (btn) btn.removeEventListener("click", handleClick);
      observer.disconnect();
    };
  }, []);


  return (
    <>
      <Head>
        <title>
          Online Shopping New Zealand - Beauty & Health, Computers, Toys, - Deals & Discounts | BestDeals
        </title>
        <meta
          name="keywords"
          content="Online Shopping New Zealand, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, BestDeals"
        ></meta>
        <meta
          name="description"
          content="Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!"
        ></meta>
      </Head>

      <DefaultLayout>
        <div className={`${styles['page-faq']} slider-wapper`}>
          <SliderBarLeft />
          <SliderBarRight />

          <div className={styles['faq-content']}>
            <div className={styles['page-title']}>Frequently Asked Questions(FAQ)</div>
            <div className={styles['page-desc']}>Need help using crazysales.com.au?</div>
            <div className={`${styles['page-desc']} padding-bottom-12`}>We strive to offer you the best buying experience online! Click on the topics below for details.</div>

            {isLoading ? (
              <>
                <Skeleton active paragraph={{ rows: 6 }} />
              </>
            ) : (
              <>
                <TabBar
                  tabList={tabList.map((category: any, index: number) => {
                    return {
                      ...category,
                      reactNode: (
                        <div className={`${styles['custom-item']} ${activeTab === index ? styles['active-item'] : ''}`}>
                          <div className={`${styles['item-icon']}`}>
                            <Image src={category.pictureActive} width={50} height={50} alt={category.title} style={activeTab === index ? { opacity: 1 } : { opacity: 0, width: '0' }} />
                            <Image src={category.picture} width={50} height={50} alt={category.title} style={activeTab !== index ? { opacity: 1 } : { opacity: 0, width: '0' }} />
                          </div>
                          <div
                            className={styles['item-name']}
                          >
                            {category.name}
                          </div>
                        </div>
                      )
                    };
                  })}
                  activeTab={activeTab}
                  tabItemRightMargin={'0px'}
                  onTabChange={handleTabChange}
                />

                <div className={styles['questions-title-box']}>
                  {pageData[activeTab]?.map((item: any, index: number) => (
                    <div
                      className={styles['title']}
                      onClick={() => scrollToTarget(index)}
                      key={`title-${activeTab}${index}`}
                    >
                      Q{index + 1}. {item.question}
                    </div>
                  ))}
                </div>

                <div className={styles['questions-box']}>
                  {pageData[activeTab]?.map((item: any, index: number) => (
                    <div key={`faq-${activeTab}${index}`}>
                      <div className={styles['title']} id={`${activeTab}${index}`}>
                        Q{index + 1}. {item.question}
                      </div>
                      <div className={styles['answer']}>{item.answer}</div>
                      <div className={styles['back-top']}>
                        <UpOutlined style={{ color: '#e6415f', marginRight: '4px' }} onClick={backToTop} />
                        <span onClick={backToTop}>Back to Top</span>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            <div className={styles['continue-shopping']}>
              <Link href={'/'} passHref legacyBehavior>
                <a rel="noopener noreferrer">
                  <Button className={styles['continue-shopping-btn']}>Continue Shopping</Button>
                </a>
              </Link>
            </div>

            {isWholesaleOpen && (
              <Wholesale
                onClose={closeWholesale}
                isWholesaleOpen={isWholesaleOpen}
              />
            )}
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}